var styleDataHash = "5913c87f";
const injectCss = () => {
  var css = `.tANjC{margin-left:0;margin-right:auto;z-index:1}.tANjC:not(.i-Cn-){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.tANjC:not(.i-Cn-){float:none;margin-right:auto}}}@container (width < 640px){.tANjC:not(.i-Cn-){float:none;margin-right:auto}}.P-BM-{margin-left:auto;margin-right:0;z-index:1}.P-BM-:not(.i-Cn-){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.P-BM-:not(.i-Cn-){float:none;margin-left:auto}}}@container (width < 640px){.P-BM-:not(.i-Cn-){float:none;margin-left:auto}}._7qHkb{clear:both;display:block}._7qHkb:not(.-ndT-){margin-left:auto;margin-right:auto;max-width:100%}.-ndT-,.i-Cn-{width:100%}.XXH7f .-ndT-,.XXH7f .i-Cn-{margin:0 -8px;width:auto}.RAil7{width:fit-content}._2UM-0{margin-left:auto;margin-right:auto;max-width:100%}._4UbEg{width:min(350px,100%)!important}.XXH7f ._4UbEg{width:50%}._0IkUk{margin-left:auto;margin-right:auto}.XXH7f ._0IkUk{width:150px}.uTyz6{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_rtlignore_default = {
  "alignLeft": "tANjC",
  "textWrapNowrap": "i-Cn-",
  "alignRight": "P-BM-",
  "alignCenter": "_7qHkb",
  "sizeFullWidth": "-ndT-",
  "renderedInTable": "XXH7f",
  "sizeOriginal": "RAil7",
  "sizeContent": "_2UM-0",
  "sizeSmall": "_4UbEg",
  "sizeSmallCenter": "_0IkUk",
  "flex": "uTyz6"
};
export {
  general_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=general.rtlignore-scss.js.map
